import React from "react";
import "./sponsors.scss";
import logo1_icon from "../../Assets/img/homepage/boston.webp";
import logo9_icon from "../../Assets/img/homepage/home-of-mom.png";
import logo10_icon from "../../Assets/img/homepage/silver.webp";
import logo12_icon from "../../Assets/img/homepage/tomy.png";
import sp5 from "../../Assets/img/homepage/sp5.png";
import sp6 from "../../Assets/img/homepage/sp6.png";
import sp7 from "../../Assets/img/homepage/sp7.jpg";
import sp8 from "../../Assets/img/homepage/sp8.jpg";
import sp9 from "../../Assets/img/homepage/sp9.png";
import sp10 from "../../Assets/img/homepage/sp10.png";
import sp11 from "../../Assets/img/homepage/sp11.png";
import sp12 from "../../Assets/img/homepage/sp12.png";
import sp13 from "../../Assets/img/homepage/sp13.png";
import sp14 from "../../Assets/img/homepage/sp14.jpg";
import sp15 from "../../Assets/img/homepage/s15.png";


const Sponsors = () => {
  return (
    <div className="sponsorsIconsWrapper">
      <img src={logo1_icon} className="sponsorsIcon" alt="" />
      <img src={logo9_icon} className="sponsorsIcon" alt="Mothering Ourselves Mindfully — The Home of Mom" />
      <img src={logo10_icon} className="sponsorsIcon" alt="" />
      <img src={logo12_icon} className="sponsorsIcon" alt="" />
      <img src={sp5} className="sponsorsIcon" alt="" />
      <img src={sp6} className="sponsorsIcon" alt="" />
      <img src={sp7} className="sponsorsIcon" alt="" />
      <img src={sp8} className="sponsorsIcon" alt="" />
      <img src={sp9} className="sponsorsIcon" alt="" />
      <img src={sp10} className="sponsorsIcon" alt="" />
      <img src={sp11} className="sponsorsIcon" alt="" />
      <img src={sp12} className="sponsorsIcon" alt="" />
      <img src={sp13} className="sponsorsIcon" alt="" />
      <img src={sp14} className="sponsorsIcon" alt="" />
      <img src={sp15} className="sponsorsIcon" alt="" />
    </div>
  );
};

export default Sponsors;
